<template>
  <!-- 这份表单是用于费罗娜pc官网用的招商表单，2020-06-02日后该表单有费罗娜官网制作方重新制作，待对方制作完成上线后，该表单即可删除 -->
  <div class="florina-merchants-form-page">
    <div class="florina-merchants-form-wrapper">
      <div class="florina-merchants-form-title">加盟费罗娜</div>
      <div class="florina-merchants-form-icon"></div>
      <div class="florina-merchants-form-tab-wrapper">
        <div
          class="florina-merchants-form-tab-item"
          v-for="item in merchantTypes"
          :key="item.id + item.name"
        >
          <span
            class="florina-merchants-form-tab-item-text"
            @click="onTypeChange(item)"
            :class="[form.typeId === item.id ? 'active' : '']"
            >{{ item.name }}</span
          >
        </div>
        <!-- <div class="florina-merchants-form-tab-item">
          <span class="florina-merchants-form-tab-item-text">设计师入口</span>
        </div>
        <div class="florina-merchants-form-tab-item">
          <span class="florina-merchants-form-tab-item-text">项目合作</span>
        </div>-->
      </div>
      <div class="florina-merchants-form-container">
        <div class="florina-merchants-form-flex-row">
          <div class="florina-merchants-form-item">
            <div class="florina-merchants-form-label">姓名：</div>
            <div class="florina-merchants-form-content">
              <el-input
                v-model.trim="form.name"
                class="florina-merchants-form-input"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="florina-merchants-form-flex-row">
          <div class="florina-merchants-form-item">
            <div class="florina-merchants-form-label">手机：</div>
            <div class="florina-merchants-form-content">
              <el-input
                v-model.trim="form.telephoneNo"
                class="florina-merchants-form-input"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="florina-merchants-form-flex-row">
          <div class="florina-merchants-form-item">
            <div class="florina-merchants-form-label">加盟城市：</div>
            <div class="florina-merchants-form-content">
              <el-cascader
                v-model="cityValue"
                :options="cityOptions"
                @change="handleCityChange"
                style="width: 100%"
                clearable
                filterable
              ></el-cascader>
            </div>
          </div>
        </div>
        <div class="florina-merchants-form-flex-row">
          <div class="florina-merchants-form-item">
            <div class="florina-merchants-form-label">公司名称：</div>
            <div class="florina-merchants-form-content">
              <el-input
                v-model.trim="form.companyName"
                class="florina-merchants-form-input"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="florina-merchants-form-flex-row">
          <div class="florina-merchants-form-item">
            <div class="florina-merchants-form-label">目前经营品牌：</div>
            <div class="florina-merchants-form-content">
              <el-input
                v-model.trim="form.brandName"
                class="florina-merchants-form-input"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="florina-merchants-form-flex-row">
          <span class="florina-merchants-form-submit" @click="onSubmit">
            提 交
            <i class="el-icon-right submit-icon"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cities from "@/api/areaData/cities.json";
import states from "@/api/areaData/states.json";
import axios from "axios";
import { isEmprty, isPhone } from "@/utils/validate";
export default {
  name: "merchantIFrameForm",
  props:{
    isSelfDevelop:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSubmiting: false,
      form: {
        brandName: "",
        city: "",
        companyName: "",
        country: "中国",
        name: "",
        province: "",
        sourceId: 3,
        telephoneNo: "",
        typeId: 1,
        promotionCompanyId: "",
        brandId:null,
        selfDevelop: false
      },
      merchantTypes: [],
      cityValue: [],
      cityOptions: [],
    };
  },
  created() {
    this.formatAreaData();
    this.getMerchantsType();
  },
  watch:{
    isSelfDevelop: {
      handler(val){
        this.form.selfDevelop = val
      },
      immediate:true
    }
  },
  methods: {
    handleCityChange(val) {
      if (val && val.length > 0) {
        this.form.province = val[0];
        this.form.city = val[1];
      } else {
        this.form.province = "";
        this.form.city = "";
      }
    },
    formatAreaData() {
      let provinceData = states["RECORDS"].filter(
        (ele) => ele.country_id == 44
      );
      let tempOptionsData = [];
      provinceData.forEach((ele) => {
        tempOptionsData.push({
          value: ele.cname,
          label: ele.cname,
          children: cities["RECORDS"]
            .filter((item) => item.state_id == ele.id)
            .map((target) => {
              return { value: target.cname, label: target.cname };
            }),
        });
      });
      this.cityOptions = tempOptionsData;
    },
    validateForm() {
      let isPass = true;
      if (isEmprty(this.form.typeId)) {
        this.$message.error("请选择类型");
        isPass = false;
        return;
      }
      if (isEmprty(this.form.name)) {
        this.$message.error("请填写名字");
        isPass = false;
        return;
      }
      if (isEmprty(this.form.telephoneNo)) {
        this.$message.error("请填写电话号码");
        isPass = false;
        return;
      }
      if (!isPhone(this.form.telephoneNo)) {
        this.$message.error("请填写正确的手机号码");
        isPass = false;
        return;
      }
      // 如果选择了非设计师的类型，需要检验城市和品牌字段
      if (this.form.typeId !== 2) {
        if (isEmprty(this.form.province) || isEmprty(this.form.city)) {
          this.$message.error("请选择您所在的城市");
          isPass = false;
          return;
        }
        if (isEmprty(this.form.companyName)) {
          this.$message.error("请填写公司名称");
          isPass = false;
          return;
        }
        // if (isEmprty(this.form.brandName)) {
        //   this.$message.error("请填写您目前经营的品牌");
        //   isPass = false;
        //   return;
        // }
      } else {
        if (isEmprty(this.form.province) || isEmprty(this.form.city)) {
          this.$message.error("请选择您所在的城市");
          isPass = false;
          return;
        }
        if (isEmprty(this.form.companyName)) {
          this.$message.error("请填写公司名称");
          isPass = false;
          return;
        }
      }
      return isPass;
    },
    getMerchantsType() {
      axios
        .get("https://erp.florina.cn:1443/api/v1/merchants/types/selections")
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.merchantTypes = res.data;
            this.form.typeId = this.merchantTypes[0].id;
          }
        })
        .catch((err) => {
          console.error("获取表单类型失败", err.response);
          this.$message.error(err.response.data.message);
        });
    },
    onTypeChange(item) {
      if (item.id == 2) {
        this.form.brandName = "";
      }
      this.form.typeId = item.id;
    },
    onSubmit() {
      if (this.validateForm()) {
        this.isSubmiting = true;
        axios
          .post("https://erp.florina.cn:1443/api/v1/merchants", this.form)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              this.isSubmiting = false;
              this.$message.success("提交成功");
              this.initForm();
            }
          })
          .catch((err) => {
            this.isSubmiting = false;
            console.error("提交失败，请稍后重试", err.response);
            this.$message.error("提交失败，请稍后重试");
          });
      }
    },
    initForm() {
      this.form = {
        brandName: "",
        city: "",
        companyName: "",
        country: "中国",
        name: "",
        province: "",
        sourceId: 3,
        typeId: 1,
        telephoneNo: "",
        promotionCompanyId: "",
      };
      this.cityValue = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.florina-merchants-form-page {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f6f7f7;
  margin: 0 auto;
  .florina-merchants-form-wrapper {
    box-sizing: border-box;
    width: 900px;
    padding: 10px 15px;
  }
  .florina-merchants-form-title {
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    color: #000;
    font-weight: 550;
    letter-spacing: 2px;
    font-family: "SourceHanSansCN-Bold";
  }
  .florina-merchants-form-icon {
    width: 100%;
    height: 40px;
    margin-top: 16px;
    margin-bottom: 70px;
    overflow: hidden;
    &::before {
      display: block;
      content: "";
      width: 22px;
      height: 22px;
      border-left: 3px solid #e9df4c;
      border-bottom: 3px solid #e9df4c;
      transform: rotateZ(-45deg);
      margin: 0 auto;
    }
  }
  .florina-merchants-form-tab-wrapper {
    box-sizing: border-box;
    width: 380px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 100px;
    font-family: "SourceHanSansCN-Regular";
    .florina-merchants-form-tab-item {
      flex: 1;
      font-size: 14px;
      text-align: center;
      color: #000;
      .florina-merchants-form-tab-item-text {
        padding-bottom: 20px;
        font-size: 15px;
        font-weight: 500;
        position: relative;
        cursor: pointer;
        &.active::before {
          content: "";
          width: 100%;
          height: 4px;
          background-color: #fee517;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }
  }
  .florina-merchants-form-container {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-family: "SourceHanSansCN-Regular";
    .florina-merchants-form-flex-row {
      box-sizing: border-box;
      flex: 390px 0 0;
      width: 390px;
      margin-bottom: 40px;
      .florina-merchants-form-item {
        box-sizing: border-box;
        width: 100%;
        height: 58px;
        border-radius: 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        overflow: hidden;
        .florina-merchants-form-label {
          font-size: 14px;
          color: #989898;
          padding: 0 10px 0 20px;
        }
        .florina-merchants-form-content {
          flex: 1;
          display: flex;
          align-items: center;
          height: 100%;
          /deep/ {
            .el-input__inner {
              border: none;
              outline: none;
            }
          }
        }
      }
      .florina-merchants-form-submit {
        display: block;
        width: 180px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        border-radius: 50px;
        color: #000;
        background-color: #ffe218;
        transition: all 0.3s linear;
        margin-top: 10px;
        cursor: pointer;
        overflow: hidden;
        .submit-icon {
          font-size: 20px;
          transition: all 0.3s linear;
          padding-left: 6px;
        }
        &:hover {
          background-color: #d8be17;
          .submit-icon {
            transform: translateX(6px);
          }
        }
      }
    }
  }
}
</style>